import QuestionSelectOption from "pages/PreviewPage/QuestionSelectOption/QuestionSelectOption";

export default QuestionSelectOption;
